'use client';
import type React from 'react';
import { useCallback } from 'react';
import { useEventContext, useSvgContext } from '../../context';
import { SvgResponsive } from '..';

interface Props {
  children: React.ReactNode;
  getHoveredTick?: (x: number) => number;
  onClick?: (tick: number) => void;
}

const SvgChart = ({ children, getHoveredTick, onClick }: Props) => {
  const { height, minWidth }: any = useSvgContext();
  const { handleHoverTick, setWidth, setMouse }: any = useEventContext();

  const handleMouseMove = useCallback(
    (x: any, y: any) => {
      if (getHoveredTick) handleHoverTick(getHoveredTick(x));
      setMouse(x, y);
    },
    [setMouse, handleHoverTick, getHoveredTick],
  );
  const svgClickHandler = useCallback(
    (...args: any) => {
      if (onClick && getHoveredTick) {
        const { clientX, currentTarget } = args[1];
        const matrix = currentTarget.getScreenCTM();
        onClick(getHoveredTick(matrix ? (clientX - matrix.e) / matrix.a : clientX));
      }
    },
    [onClick, getHoveredTick],
  );

  return (
    <SvgResponsive
      height={height}
      minWidth={minWidth}
      onChangeWidth={setWidth}
      onClick={svgClickHandler}
      onMouseMove={handleMouseMove}
    >
      {children}
    </SvgResponsive>
  );
};

export default SvgChart;
